export default "__VITE_ASSET__CovvT57d__"